<template>
    <div v-if="hasAccess" class="app-menu h-full fixed pin-x pin-y" @click.self="onClickBackground">
        <div class="app-menu-inner h-full">
            <div class="mx-auto py-10" @click.self="onClickBackground">
                <h2 class="text-center text-blue" @click.self="onClickBackground">Profile</h2>
            </div>

            <div class="flex items-center justify-center rounded-lg m-4 pt-8 pb-2 bg-white shadow-lg">
                <div class="w-full md:w-1/2 flex flex-wrap sm:flex-wrap-reverse lg:flex-wrap mx-auto -mx-4">
                    <app-icon
                            v-for="item in menuItems"
                            :key="item.label"
                            :route="item.route"
                            :label="trans(item.trans)"
                            :icon="item.icon"
                            :badge="item.label === 'Documents' && expiredDocuments > 0 ? expiredDocuments : item.badge"
                    >
                    </app-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import menu from '@/menu'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],

        computed: {
            ...mapState(['employee_extended']),

            menuItems() {
                let subItems = menu.find(item => item.route === this.$router.currentRoute.path).subItems;
                return subItems.filter(item => item.display) || [];
            },
        },

        methods: {
            onClickBackground() {
                this.$router.push('/')
            }
        }

    }
</script>

<style>
</style>